import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import urlHandler from '../../../utils/urlHandler';
import {FormBuilder, FieldArray} from 'react-reactive-form';
import renderer from './renderers';

class LinkProgress extends Component {
    render() {
        return (
            <span className="link-searching">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Searching ...
            </span>
        );
    }
}

class LinkLookupControl extends Component {
    constructor(props){
        super(props);

        this.onLookup = this.onLookup.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onLink = this.onLink.bind(this);
        this.onSelectResult = this.onSelectResult.bind(this);

        this.state = {
            show: false,
            inProgress: false,
            results: null,
            selected: null,
            selectedData: null
        }
    };

    onLookup() {
        if (!this.props.query || this.props.query.length == 0) {
            return;
        }

        // need to convert to promises instead of callbacks by reimplementing sendKBQueryRequest before can use this
        // const cleanedKBNames = (!this.props.kbname || this.props.kbName.includes('ALL')) ? ["ORGANIZATIONS", "PEOPLE", "THINGS"] : 
        //     this.props.kbNames.filter((n)=> ["ORGANIZATIONS", "PEOPLE", "THINGS"].includes(k))
        
        this.setState({
            show: true,
            inProgress: true
        },() => {
            var merged = [];
            urlHandler.sendKbQueryRequest(this.props.query, null, 'ORGANIZATIONS', (response, status) => {
                if (response && response.results && response.results.length > 0) {
                    merged = merged.concat(response.results);
                }
                urlHandler.sendKbQueryRequest(this.props.query, null, 'PEOPLE', (response1, status) => {
                    if (response1 && response1.results && response1.results.length > 0) {
                        merged = merged.concat(response1.results);
                    }
                    urlHandler.sendKbQueryRequest(this.props.query, null, 'THINGS', (response2, status) => {
                        if (response2 && response2.results && response2.results.length > 0) {
                            merged = merged.concat(response2.results);
                        }
                        this.setState({
                            inProgress: false,
                            results: merged,
                            selectedData: null,
                            selected: -1
                        });
                    });
                });
            });
        })
    }

    onClose() {
        this.setState({
            show: false,
            inProgress: false,
            results: null
        });
    }

    onLink() {
        if (this.state.selectedData) {
            this.setState({
                show: false,
                inProgress: false,
                results: null
            }, () => {

                var doc = this.state.selectedData.document;
                var control = this.props.form.get(this.props.formField).controls;
                if (this.props.fieldIndex != undefined) {
                    control = control[this.props.fieldIndex];
                }
                control.controls['finchId'].setValue(doc.id);
                control.controls['label'].setValue(doc.label);
                if (doc.permIds && doc.permIds.length > 0) {
                    control.controls['permId'].setValue(doc.permIds[0]);
                }
            });
        }
    }

    onSelectResult(state, rowInfo, column, instance) {
        if (rowInfo) {
            if (rowInfo.index === this.state.selected) {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        background: '#E9ECE0',
                        cursor: 'pointer'
                    }
                };
            } else {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        cursor: 'pointer'
                    }
                };                
            }
    
        } else {
            return {}
        }
    }

    render() {

        const columns = [{
            Header: 'Id',
            accessor: 'document.id'
        }, {
            Header: 'Label',
            accessor: 'document.label',
            style: {'whiteSpace': 'unset'}
        }, {
            Header: 'Description',
            accessor: 'document.description',
            style: {'whiteSpace': 'unset'}
        }, {
            Header: 'Perm Ids',
            accessor: 'document.permIds', Cell: (row) => (
                <div>
                {(row.original.document.permIds && row.original.document.permIds.length > 0) ?
                    <div>
                        {row.original.document.permIds.map((id, index) => {
                            return <div key={index}>{id}</div>
                        })}
                    </div>
                :
                    <div></div>
                }
                </div>
            )
        }];

        return (
            <table className="link-lookup-wrapper">
                <tbody>
                    <tr>
                        <td className="link-lookup-button">
                            <button className="form-primary-button" onClick={this.onLookup} title="Knowledgebase Lookup" disabled={this.state.show}>
                                <span className="fa fa-link"/>
                            </button>
                        </td>
                        <td className="link-lookup-results">
                        {this.state.show && 
                            <span>
                                {this.state.inProgress &&
                                    <LinkProgress/>
                                }
                                {this.state.results &&
                                    <div>
                                        <div>
                                            <div>
                                                {this.state.results.length > 0 ?
                                                    <div>    
                                                        <span className="link-lookup-description">
                                                            Below is a list of possible matches from the Knowledgebase. Select one to link to and click Link.<br/>
                                                        </span>
                                                        <br/>                                           
                                                        <ReactTable className="link-table -striped"
                                                            data={this.state.results}
                                                            columns={columns}
                                                            showPagination={false}
                                                            minRows={0}
                                                            defaultPageSize={this.state.results.length}
                                                            getTdProps={this.onSelectResult}
                                                        />
                                                    </div>
                                                :
                                                    <div>No results found.</div>
                                                }
                                            </div>
                                            <div>
                                                <span className="link-lookup-footer">
                                                    <button className="form-default-button link-lookup-cancel" onClick={this.onClose}>Cancel</button>   
                                                    <button className="form-primary-button" onClick={this.onLink}>Link</button> 
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </span>
                        }
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };
}

LinkLookupControl.propTypes = {
    kbNames: PropTypes.arrayOf(PropTypes.string),
    query: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    formField: PropTypes.string.isRequired,
    fieldIndex: PropTypes.number
};

export default LinkLookupControl;

